import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SitemapGenerator from './components/SitemapGenerator';

function App() {
  return (
    <Router>
      <div className="App">
        <SitemapGenerator />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;